








































import { Component, Vue, Watch, Ref, Prop } from 'vue-property-decorator';
import {
  getAutoScrollDistance,
  getScrollState,
  ScrollerState,
} from './business';

export type NavTabInfo = {
  /** 分类名称 */
  name: string;
  /** 分类ID */
  id: string | number;
  /** 当前分类选中标识 */
  actived?: boolean;
  /** 其他携带字段 */
  [key: string]: any;
};
/**
 * 导航分类切换
 */
@Component
export default class NavTabs extends Vue {
  @Ref('container') container!: HTMLElement;
  /**
   * 分裂列表项
   */
  @Prop({ default: [] }) public list!: NavTabInfo[];
  /**
   * 点击两端分类自动滑动的距离（单位：px）
   */
  @Prop({ default: 120 }) public autoScrollDistance!: number;
  /**
   * 分类项离边线的距离，小于这个距离点击后自动滑动距离
   */
  @Prop({ default: 40 }) public autoScrollOffset!: number;

  // 当前滚动条状态
  scrollState = ScrollerState.start;
  // 动画线条样式参数
  lineStyleObj = {
    pos: 0,
    width: 0,
  };
  dataList: NavTabInfo[] = [];
  activeId: string | number = '';

  /**
   * 是否有分类数据
   */
  get isExistData() {
    return this.dataList.length > 0;
  }

  /**
   * 滚动条是否在最左侧
   */
  get isAtStart() {
    return this.scrollState === ScrollerState.start;
  }

  /**
   * 滚动条是否在最右侧
   */
  get isAtEnd() {
    return this.scrollState === ScrollerState.end;
  }

  get lineStyle() {
    const { pos, width } = this.lineStyleObj;
    return {
      transform: `translateX(${pos}px)`,
      width: `${width}px`,
    };
  }

  @Watch('list')
  initData() {
    if (!this.list.length) {
      return [];
    }
    const currActived = this.list.find(item => item.actived) || this.list[0];
    this.dataList = JSON.parse(JSON.stringify(this.list)) as NavTabInfo[];
    // 设置分类选中项
    this.activeId = currActived.id;
    const activedItem = this.dataList.find(item => item.actived);
    if (activedItem) {
      activedItem.actived = false;
      this.handleSwitchTab(activedItem, true);
    }
  }

  @Watch('activeId')
  notifyActiveIdChanged() {
    const tab = this.dataList.find(item => item.actived);
    if (tab) {
      tab.actived = false;
    }
    const nextTab = this.dataList.find(item => item.id === this.activeId);
    if (nextTab) {
      nextTab.actived = true;
      // 设置选中项选中动画
      this.$nextTick(this.setNavTabActivedAnim);
      this.$emit('change', nextTab);
    }
  }

  /**
   * 设置选中项选中动画
   */
  setNavTabActivedAnim() {
    const [el] = this.container.getElementsByClassName('actived');
    const { scrollLeft } = this.container;
    const parentLeft = this.container.getBoundingClientRect().left;
    if (el) {
      const { left, width } = el.getBoundingClientRect();
      // 滚动到选中项，确保选中项能展示出来
      // el.scrollIntoView();
      // 设置选中项底部位置及动画
      Object.assign(this.lineStyleObj, {
        pos: left + scrollLeft - parentLeft,
        width,
      });
    }
  }

  /**
   * 点击2侧的分类项，自动调整分类列表滚动位置，确保用户能看到更多隐藏信息
   */
  adjustTabPosition(el: HTMLElement) {
    const {
      container,
      autoScrollDistance: defDistance,
      autoScrollOffset: defOffset,
    } = this;
    if (this.container) {
      const distance = getAutoScrollDistance(
        el,
        container,
        defDistance,
        defOffset,
      );
      if (distance !== 0) {
        setTimeout(() => {
          this.container.scrollBy({ left: distance });
        });
      }
    }
  }
  /**
   * 点击切换分类
   */
  handleSwitchTab(navTab: NavTabInfo, forceUpdate = false) {
    if (!navTab.actived) {
      if (forceUpdate) {
        this.activeId = '';
      }
      this.$nextTick(() => {
        this.activeId = navTab.id;
        const el = this.container.querySelector(`[data-cid="${navTab.id}"]`);
        if (el) {
        // 滚动列表，展示更多隐藏区域选项
          this.adjustTabPosition(el as HTMLElement);
        }
      });
    }
  }

  /**
   * 监测列表滚动行为，控制右侧遮罩蒙层展示
   */
  handleScroll() {
    this.scrollState = getScrollState(this.container);
  }

  /**
   * 切换到指定的ID分类项目
   */
  switchTab(id: string | number) {
    const navtab = this.list.find(item => item.id === id);
    if (navtab) {
      this.handleSwitchTab(navtab);
    }
  }

  created() {
    this.initData();
  }
}
